export default __webpack_public_path__ + "static/media/Gloves of Swiftstriking.f0f7c10b.jpg";